import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';
import { getAnalytics } from 'firebase/analytics';
import { getAuth } from 'firebase/auth';

//Firebase configuration
const firebaseConfig = {
    apiKey: "AIzaSyDm9fL6xVWoctIYDu-GwplHIqiyR3TJckg",
    authDomain: "muslim-corporate-academy.firebaseapp.com",
    projectId: "muslim-corporate-academy",
    storageBucket: "muslim-corporate-academy.firebasestorage.app",
    messagingSenderId: "1094433416183",
    appId: "1:1094433416183:web:f6fcdf093cab5ffcdec4f2",
    measurementId: "G-HKKQTCNE73"
  };

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Analytics only in browser environment
if (typeof window !== 'undefined') {
  try {
    getAnalytics(app);
  } catch (error) {
    console.log('Analytics not available:', error);
  }
}

// Initialize Firestore
export const db = getFirestore(app);

// Auth (blog admin login), gated by Security Rules server-side (see
// firestore.rules), not by anything in this file. Blog image uploads use
// Cloudinary instead of Firebase Storage - see services/storageService.js -
// to avoid Firebase Storage's Blaze/billing requirement.
export const auth = getAuth(app);

export default app;
